import Navbar from "../components/global-components/navbar-v4";
import PageHeader from "../components/global-components/page-header";
import ShopLeftSidebar from "../components/shop-components/shop-left-sidebar";

function ListProperti() {
	return (
		<div>
			<Navbar CustomClass="ltn__header-transparent gradient-color-2" />
			<PageHeader headertitle="Sewa Properti Rumah" />
			<ShopLeftSidebar />
		</div>
	);
}

export default ListProperti;
